export default [
  {
    path: '/services/list',
    name: 'services-list',
    component: () => import('@/views/services/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Services List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Services' }, { title: 'Services List', active: true }],
      permissions: ['service_list']
    }
  },
  {
    path: '/service/add',
    name: 'create-service',
    component: () => import('@/views/services/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add Service',
      parent: 'servicesList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Services', url: '/services/list' },
        { title: 'Add Services', active: true }
      ],
      permissions: ['service_create']
    }
  },
  {
    path: '/service/:id/edit',
    name: 'edit-service',
    component: () => import('@/views/services/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Services',
      parent: 'servicesList',       
      permissions: ['service_edit']
    }
  },   
]
